import React from "react";
import {
  getAverageBySongs,
  getResultClassName,
  getTotalBySongs,
  isPenaltyChecked,
} from "../../../../utils/scoreUtils";
import { GroupData } from "@/types/GroupData";

interface ResultTableProps {
  group: GroupData;
  songIndexes: number[];
  editableResults: { [key: string]: string };
  editablePenalties: { [key: string]: boolean };
  isEditMode: boolean;
  handleChange: (key: string, value: string) => void;
  handlePenaltyChange: (key: string, checked: boolean) => void;
  selectedTab: string;
  isSaving?: boolean;
}

const ResultTable: React.FC<ResultTableProps> = ({
  group,
  songIndexes,
  editableResults,
  editablePenalties,
  isEditMode,
  handleChange,
  handlePenaltyChange,
  selectedTab,
  isSaving = false,
}) => {
  const getResultValue = (group: GroupData, resultKey: string): string =>
    String(group[resultKey as keyof GroupData] ?? "");

  return (
    <table className="result-table">
      <thead>
        <tr>
          <th style={{ width: "160px" }}>
            <span className="total-point">
              {getTotalBySongs(group, editableResults, isEditMode, songIndexes)}
            </span>
          </th>
          <th style={{ paddingLeft: "20px" }}>
            songs
            {selectedTab === "QuartetContest" &&
              (songIndexes[0] === 1 || songIndexes[0] === 2
                ? "：Semi Final"
                : "：Final")}
          </th>
          {["Mus", "Per", "Sng"].map((type) => (
            <th key={type} className="center">
              <p>{type}</p>
              <p className="th-ave">
                {getAverageBySongs(
                  group,
                  editableResults,
                  isEditMode,
                  songIndexes,
                  [type as "Mus" | "Per" | "Sng"],
                )}
              </p>
            </th>
          ))}
          <th className="center">
            <p>Total</p>
            <p className="th-ave">
              {getAverageBySongs(
                group,
                editableResults,
                isEditMode,
                songIndexes,
              )}
            </p>
          </th>
        </tr>
      </thead>
      <tbody>
        {songIndexes.map((num) => (
          <tr key={num}>
            <td></td>
            <td className="songs">
              <p className="main-text">
                {String(group[`songName${num}` as keyof GroupData] ?? "")}
                <span className="sub-text">
                  [
                  {String(group[`songArranged${num}` as keyof GroupData] ?? "")}
                  ]
                </span>
              </p>
            </td>
            {["Mus", "Per", "Sng"].map((type, colIndex) => {
              const resultKey = `songResult${type}${num}`;
              const penaltyKey = `songPenalty${type}${num}`;

              return (
                <td key={resultKey} className="score">
                  {isEditMode ? (
                    <div className="flex">
                      <input
                        type="text"
                        value={editableResults[resultKey] ?? ""}
                        onChange={(e) =>
                          handleChange(resultKey, e.target.value)
                        }
                        style={{ width: "50px" }}
                        disabled={isSaving}
                      />
                      <input
                        className="penaltycheck"
                        type="checkbox"
                        checked={isPenaltyChecked(
                          penaltyKey,
                          true,
                          group,
                          editablePenalties,
                        )}
                        onChange={(e) =>
                          handlePenaltyChange(penaltyKey, e.target.checked)
                        }
                        disabled={isSaving}
                      />
                    </div>
                  ) : (
                    <div className="flex" style={{ justifyContent: "center" }}>
                      <p
                        className={getResultClassName(
                          type,
                          penaltyKey,
                          false,
                          group,
                          editablePenalties,
                        )}
                      >
                        {getResultValue(group, resultKey)}
                      </p>
                    </div>
                  )}
                </td>
              );
            })}
            <td className="total score">
              {getAverageBySongs(group, editableResults, isEditMode, [num])}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ResultTable;
